/**
 * Best-effort Tab-Keepalive: spielt ein praktisch unhörbares Audiosignal dauerhaft ab.
 * Browser drosseln Tabs, die *Audio ausgeben*, deutlich weniger aggressiv als stille
 * Hintergrund-Tabs. Damit laufen WS/Timer/Reconnect-Logik (Main-Thread) zuverlässiger
 * weiter, wenn der Sprecher den Tab in den Hintergrund schiebt (Skript in Word o.ä.).
 *
 * KEINE Garantie — manche Browser (v.a. Firefox) drosseln nicht-fokussierte Tabs teils
 * trotzdem. Die eigentliche Robustheit kommt aus den großzügigen Reconnect-Fenstern
 * (`GIVEUP_WINDOW_MS`) + dem Studio, das einen zurückkehrenden Speaker automatisch wieder
 * annimmt. Der Keepalive reduziert nur die Drosselung, er ersetzt die Toleranz nicht.
 *
 * Gain ist ~ -80 dBFS (unhörbar) bei 40 Hz — selbst auf Kopfhörern nicht wahrnehmbar.
 */
export function startKeepAlive(): () => void {
  let ctx: AudioContext | null = null;
  let osc: OscillatorNode | null = null;
  try {
    ctx = new AudioContext();
    osc = ctx.createOscillator();
    const gain = ctx.createGain();
    gain.gain.value = 0.0001; // ~ -80 dBFS → unhörbar, aber nicht 0 → Tab gilt als "spielt Audio"
    osc.frequency.value = 40; // tief, unhörbar
    osc.connect(gain).connect(ctx.destination);
    osc.start();
    void ctx.resume();
  } catch {
    /* kein AudioContext verfügbar → Keepalive entfällt, Toleranz-Pfad greift trotzdem */
  }
  return () => {
    try { osc?.stop(); } catch { /* schon gestoppt */ }
    void ctx?.close();
  };
}
